// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/calendar.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchActivity {
    padding: 1rem;
    border-left: 6px solid;
    border-left-color: #e50000;
    border-right: 6px solid;
    border-right-color: #e50000;
    border-top: 1px solid;
    border-top-color: #000000;
    border-bottom: 1px solid;
    border-bottom-color: #000000;
}

.hrClass {
    padding: 0px !important;
}

.searchActivity .noPadding {
    padding: 0px;
}

.searchActivity .css-10nd86i svg {
    color: #e50000;
}

.searchActivity .css-1492t68 {
    text-indent: -9999px;
}

.searchActivity .css-va7pk8 {
    color: #595d60 !important;
}

.searchActivity .react-datepicker__input-container {
    width: 11.7rem;
}

.bigDD-toyota .react-datepicker__close-icon::after {
    background-color: #e50000;
}

.bigDD-lexus .react-datepicker__close-icon::after {
    background-color: #252525;
}

.searchActivity #startDate, .searchActivity #completeDate, .searchActivity #startDateTo, .searchActivity #completeDateTo {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right;
    cursor: pointer;
}

.Select-menu-outer {
    max-height: 1000px;
}

.Select-menu {
    max-height: 998px;
}

.bigDD-toyota .css-1r4vtzz, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {
    width: 11.7rem;
}

.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg {
    color: #e50000 !important;
}

.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg {
    color: #252525 !important;
}

.smallDD-toyota .css-1r4vtzz svg, .smallDD-toyota .css-48ayfv svg {
    color: #e50000 !important;
}

.smallDD-lexus .css-1r4vtzz svg, .smallDD-lexus .css-48ayfv svg {
    color: #252525 !important;
}

.smallDD-toyota .css-1r4vtzz, .smallDD-toyota .css-48ayfv, .smallDD-toyota .react-datepicker__input-container, .smallDD-lexus .css-1r4vtzz, .smallDD-lexus .css-48ayfv, .smallDD-lexus .react-datepicker__input-container {
    width: 9rem;
}

.searchActivity .react-autosuggest__container {
    position: relative;
}

.searchActivity .react-autosuggest__input {
    padding: 10px 10px;
    border: 1px solid #aaa;
    border-color: rgb(219, 212, 212);
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 11.7rem;

}

/* .addEditActivityModal .react-autosuggest__input--focused {
    border-radius: 0.25rem !important;
  } */

.searchActivity .react-autosuggest__input--open {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-radius: 0.25rem !important;
    height: calc(2.25rem + 2px);
    width: 11.7rem;
    
}

.searchActivity .react-autosuggest__suggestions-container--open {
    display: block;
    min-width: 11.7rem;
    border: 1px solid #aaa;
    border-radius: 0.25rem !important;
}

.searchActivity .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
}

.searchActivity .react-autosuggest__suggestion {
    cursor: pointer;
    padding: 10px 20px;
    background-color: white;
}

.searchActivity .react-autosuggest__suggestion--highlighted {
    background-color: #ddd;
}

#react-autowhatever-1 {
    position: absolute;
    z-index: 9999;
    background: white;
}

.css-15brt4p {
    display: none !important;
}

.css-11unzgr {
    border: 0.5px solid #aaa !important;
}
.searchActivity .form-control{
    height: calc(2.25rem + 2px) !important;
}
.searchActivity .css-ssi0ig-container{
    width: 11.7rem;
}


.activeSelectActivityId{
    width: 9.4rem !important;
}

.activeField-toyota .css-1wy0on6 svg{
    color: #e50000 ;
}

.activeField-lexus .css-1wy0on6 svg{
    color: #252525 ;
}

.activitysStatus .css-10nd86i .css-1hwfws3 .css-1492t68 {
    text-indent: -9999px;
}

.activitysStatus .css-10nd86i{
    max-width: 200px  !important;
}

.activitysStatus .css-10nd86i .css-15brt4p{
    min-width: 184px !important;
}

.activitysStatus .css-10nd86i .css-1kuo3lu{
    min-width: 184px !important;
}

.activitysStatus .css-11unzgr{
    overflow: visible  !important;
}

.activitysStatus .css-11unzgr .css-lc91z5{
    min-width: 198px  !important;
}


.vcActivityStatus{
    padding-right: 0px !important;
    width:9.4rem !important;
}

.activitysStatus .css-ik6y5r .css-11unzgr .css-19lyk4y{
    min-width: 198px  !important;
}

.searchIcon-toyota{
    color: #e50000 !important;
}

.searchIcon-lexus{
color: #252525 !important
}

.activeSelectActivityId .css-11unzgr{
    max-height: 200px !important;
}

.activeSelectActivityId .css-ivrpdj{
    max-height: 200px !important;
}

/* new code */
.fa-3x {
    float: left !important;
}
/* .regionDropdownFilter {
display:block;
} */




`, "",{"version":3,"sources":["webpack://./src/components/searchActivity/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;IACxB,4BAA4B;AAChC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yDAAyD;IACzD,4BAA4B;IAC5B,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,gCAAgC;IAChC,iCAAiC;IACjC,2BAA2B;IAC3B,cAAc;;AAElB;;AAEA;;KAEK;;AAEL;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,iCAAiC;IACjC,2BAA2B;IAC3B,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA;IACI,SAAS;IACT,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mCAAmC;AACvC;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,cAAc;AAClB;;;AAGA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;AAChC;;;AAGA;IACI,6BAA6B;IAC7B,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;AACA;AACA;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA,aAAa;AACb;IACI,sBAAsB;AAC1B;AACA;;GAEG","sourcesContent":[".searchActivity {\n    padding: 1rem;\n    border-left: 6px solid;\n    border-left-color: #e50000;\n    border-right: 6px solid;\n    border-right-color: #e50000;\n    border-top: 1px solid;\n    border-top-color: #000000;\n    border-bottom: 1px solid;\n    border-bottom-color: #000000;\n}\n\n.hrClass {\n    padding: 0px !important;\n}\n\n.searchActivity .noPadding {\n    padding: 0px;\n}\n\n.searchActivity .css-10nd86i svg {\n    color: #e50000;\n}\n\n.searchActivity .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.searchActivity .css-va7pk8 {\n    color: #595d60 !important;\n}\n\n.searchActivity .react-datepicker__input-container {\n    width: 11.7rem;\n}\n\n.bigDD-toyota .react-datepicker__close-icon::after {\n    background-color: #e50000;\n}\n\n.bigDD-lexus .react-datepicker__close-icon::after {\n    background-color: #252525;\n}\n\n.searchActivity #startDate, .searchActivity #completeDate, .searchActivity #startDateTo, .searchActivity #completeDateTo {\n    background-image: url(\"../../assets/images/calendar.png\");\n    background-repeat: no-repeat;\n    background-position: right;\n    cursor: pointer;\n}\n\n.Select-menu-outer {\n    max-height: 1000px;\n}\n\n.Select-menu {\n    max-height: 998px;\n}\n\n.bigDD-toyota .css-1r4vtzz, .bigDD-toyota .css-48ayfv, .bigDD-lexus .css-1r4vtzz, .bigDD-lexus .css-48ayfv {\n    width: 11.7rem;\n}\n\n.bigDD-toyota .css-1r4vtzz svg, .bigDD-toyota .css-48ayfv svg {\n    color: #e50000 !important;\n}\n\n.bigDD-lexus .css-1r4vtzz svg, .bigDD-lexus .css-48ayfv svg {\n    color: #252525 !important;\n}\n\n.smallDD-toyota .css-1r4vtzz svg, .smallDD-toyota .css-48ayfv svg {\n    color: #e50000 !important;\n}\n\n.smallDD-lexus .css-1r4vtzz svg, .smallDD-lexus .css-48ayfv svg {\n    color: #252525 !important;\n}\n\n.smallDD-toyota .css-1r4vtzz, .smallDD-toyota .css-48ayfv, .smallDD-toyota .react-datepicker__input-container, .smallDD-lexus .css-1r4vtzz, .smallDD-lexus .css-48ayfv, .smallDD-lexus .react-datepicker__input-container {\n    width: 9rem;\n}\n\n.searchActivity .react-autosuggest__container {\n    position: relative;\n}\n\n.searchActivity .react-autosuggest__input {\n    padding: 10px 10px;\n    border: 1px solid #aaa;\n    border-color: rgb(219, 212, 212);\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 11.7rem;\n\n}\n\n/* .addEditActivityModal .react-autosuggest__input--focused {\n    border-radius: 0.25rem !important;\n  } */\n\n.searchActivity .react-autosuggest__input--open {\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    border-radius: 0.25rem !important;\n    height: calc(2.25rem + 2px);\n    width: 11.7rem;\n    \n}\n\n.searchActivity .react-autosuggest__suggestions-container--open {\n    display: block;\n    min-width: 11.7rem;\n    border: 1px solid #aaa;\n    border-radius: 0.25rem !important;\n}\n\n.searchActivity .react-autosuggest__suggestions-list {\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n}\n\n.searchActivity .react-autosuggest__suggestion {\n    cursor: pointer;\n    padding: 10px 20px;\n    background-color: white;\n}\n\n.searchActivity .react-autosuggest__suggestion--highlighted {\n    background-color: #ddd;\n}\n\n#react-autowhatever-1 {\n    position: absolute;\n    z-index: 9999;\n    background: white;\n}\n\n.css-15brt4p {\n    display: none !important;\n}\n\n.css-11unzgr {\n    border: 0.5px solid #aaa !important;\n}\n.searchActivity .form-control{\n    height: calc(2.25rem + 2px) !important;\n}\n.searchActivity .css-ssi0ig-container{\n    width: 11.7rem;\n}\n\n\n.activeSelectActivityId{\n    width: 9.4rem !important;\n}\n\n.activeField-toyota .css-1wy0on6 svg{\n    color: #e50000 ;\n}\n\n.activeField-lexus .css-1wy0on6 svg{\n    color: #252525 ;\n}\n\n.activitysStatus .css-10nd86i .css-1hwfws3 .css-1492t68 {\n    text-indent: -9999px;\n}\n\n.activitysStatus .css-10nd86i{\n    max-width: 200px  !important;\n}\n\n.activitysStatus .css-10nd86i .css-15brt4p{\n    min-width: 184px !important;\n}\n\n.activitysStatus .css-10nd86i .css-1kuo3lu{\n    min-width: 184px !important;\n}\n\n.activitysStatus .css-11unzgr{\n    overflow: visible  !important;\n}\n\n.activitysStatus .css-11unzgr .css-lc91z5{\n    min-width: 198px  !important;\n}\n\n\n.vcActivityStatus{\n    padding-right: 0px !important;\n    width:9.4rem !important;\n}\n\n.activitysStatus .css-ik6y5r .css-11unzgr .css-19lyk4y{\n    min-width: 198px  !important;\n}\n\n.searchIcon-toyota{\n    color: #e50000 !important;\n}\n\n.searchIcon-lexus{\ncolor: #252525 !important\n}\n\n.activeSelectActivityId .css-11unzgr{\n    max-height: 200px !important;\n}\n\n.activeSelectActivityId .css-ivrpdj{\n    max-height: 200px !important;\n}\n\n/* new code */\n.fa-3x {\n    float: left !important;\n}\n/* .regionDropdownFilter {\ndisplay:block;\n} */\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
